<template>
  <div>
    <Navbar/>
    <Homepage/>
  </div>
</template>
<script>
import Navbar from '@/components/homepage/Navbar'
import Homepage from '@/components/homepage/Homepage'
export default {
  components: {
    Navbar,
    Homepage
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/homepage/Home.vue